import React, { useState, useMemo } from "react";
import { CollapseGroupContext } from "./Collapse.context";
var CollapseGroup = function (_a) {
    var children = _a.children;
    var _b = useState(undefined), activeCollapse = _b[0], setActiveCollapse = _b[1];
    var contextValue = useMemo(function () { return ({
        activeCollapse: activeCollapse,
        setActiveCollapse: setActiveCollapse,
    }); }, [activeCollapse, setActiveCollapse]);
    return React.createElement(CollapseGroupContext.Provider, { value: contextValue }, children);
};
export default CollapseGroup;
